export enum ActionTypes {
  SHOW_GEOFENCES = 'SHOW_GEOFENCES',
  HIDE_GEOFENCES = 'HIDE_GEOFENCES',
  TOGGLE_SHOW_GEOFENCES = 'TOGGLE_SHOW_GEOFENCES',
  TOGGLE_SHOW_GEOFENCES_FORCE_VISIBILITY = 'TOGGLE_SHOW_GEOFENCES_FORCE_VISIBILITY',
  SHOW_GEOFENCES_FORCE_VISIBILITY = 'SHOW_GEOFENCES_FORCE_VISIBILITY',
  HIDE_GEOFENCES_FORCE_VISIBILITY = 'HIDE_GEOFENCES_FORCE_VISIBILITY',
}
